import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  DialogContent,
  Grid,
  Modal,
} from "@material-ui/core";
import DescriptionRoundedIcon from "@material-ui/icons/DescriptionRounded";

import { Carousel } from "react-responsive-carousel";

import { PdfImgWrapperDiv } from "../documentModal/styles/DocumentModal";
import {
  ButtonCancel,
  ButtonSave,
  CloseIconStyle,
  DialogHeader,
  DialogStyle,
} from "../modal/Modal";
import { useDocumentDialogController } from "./controller/DocumentDialogController";
import { convertDocumentData } from "./utils/DocumentDataConverter";
import { getDocumentTypes } from "../../repositories/portal_api/DocumentType";
import BodyEditDocumentData from "./children/BodyEditDocumentData";

const DocumentDialog = ({ onClose, isOpen, loading, documents }) => {
  const [listDocuments, setListDocuments] = useState([]);
  const [page, setPage] = useState(0);
  const [disabled, setDisabled] = useState(false);

  const { sendDocument } = useDocumentDialogController();

  const [documentTypes, setDocumentTypes] = useState([]);

  const normalizeDocuments = (documents) => {
    // goes inside document.data
    for (const document of documents) {
      const normalizedDocument = convertDocumentData(document);
      setListDocuments((prev) => [...prev, normalizedDocument]);
    }
  };

  useEffect(() => {
    normalizeDocuments(documents);
  }, [documents]);

  useEffect(() => {
    const initialSetup = async () => {
      const response = await getDocumentTypes();
      if (response.data) {
        setDocumentTypes(response.data);
      }
    };
    initialSetup();
  }, []);

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        onClose();
      }}
    >
      <DialogStyle style={{ width: "1200px", maxHeight: "100%" }}>
        <DialogHeader id="alert-dialog-title">
          <div className="row">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              Analise de Documentos
            </div>
            <CloseIconStyle
              style={{ marginRight: "6px" }}
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </DialogHeader>

        <DialogContent style={{ height: 480 }}>
          <Carousel
            showStatus={false}
            showThumbs={false}
            animationHandler="slide"
            showIndicators={false}
            onChange={(index, item) => {
              setPage(index);
            }}
            style={{ background: "green" }}
          >
            {loading ? (
              <div
                style={{
                  height: 400,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            ) : (
              listDocuments.map((documentData, index) => {
                return (
                  <Grid key={"DOCUMENT" + index}>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        padding: 2,
                      }}
                    >
                      <Grid item xs={12} style={{ maxHeight: "80%" }}>
                        <div
                          style={{ marginBottom: 10 }}
                          key={"DOCTAB_" + index}
                        >
                          <span>
                            <Grid
                              item
                              container
                              xs={12}
                              style={{ maxHeight: 400 }}
                            >
                              <Grid xs={6}>
                                <div
                                  style={{
                                    borderRight: "1px solid #CFD8DC",
                                    height: 400,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      color: loading
                                        ? "grey"
                                        : documentData.documentType === "OTHER"
                                        ? "#F44336"
                                        : "#4CAF50",
                                    }}
                                  >
                                    <DescriptionRoundedIcon
                                      style={{
                                        color: loading
                                          ? "grey"
                                          : documentData.documentType ===
                                            "OTHER"
                                          ? "#F44336"
                                          : "#4CAF50",
                                      }}
                                    />
                                    {documentData.fileName}
                                  </div>
                                  {/* 
                                {loading && (
                                  <PdfIframe
                                    title={`document_${index}`}
                                    src={
                                      "data:application/pdf;base64," +
                                      documentData.fileBase64 +
                                      "#toolbar=0&navpanes=0#zoom=10?id=" +
                                      Math.random()
                                    }
                                    scrolling="no"
                                  />
                                )} */}

                                  {!loading && (
                                    <PdfImgWrapperDiv>
                                      <iframe
                                        height="350"
                                        id="iframepdf"
                                        src={
                                          "data:application/pdf;base64," +
                                          documentData.fileBase64
                                        }
                                        title="iframePdfDocument"
                                        style={{ width: "100%" }}
                                      />
                                    </PdfImgWrapperDiv>
                                  )}
                                </div>
                              </Grid>

                              <Grid xs={6}>
                                {loading ? (
                                  <CircularProgress />
                                ) : (
                                  <div
                                    style={{
                                      borderBottomLeftRadius: 10,
                                      borderBottomRightRadius: 10,
                                      minHeight: 400,
                                      maxHeight: 400,
                                      overflowY: "scroll",
                                      overflowX: "hidden",
                                    }}
                                  >
                                    <BodyEditDocumentData
                                      documentData={documentData}
                                      setListDocuments={setListDocuments}
                                      documentTypes={documentTypes}
                                      documentIndex={index}
                                      listDocuments={listDocuments}
                                    />
                                  </div>
                                )}
                              </Grid>
                            </Grid>

                            <div
                              style={{
                                marginTop: 10,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                {page !== 0 && listDocuments?.length !== 1 && (
                                  <ButtonCancel
                                    loading={disabled || loading}
                                    color="variant"
                                    aria-label="add"
                                    onClick={() => {
                                      window.document
                                        .getElementsByClassName(
                                          "control-arrow control-prev"
                                        )[0]
                                        .click();
                                    }}
                                  >
                                    Voltar
                                  </ButtonCancel>
                                )}
                              </div>

                              <div>
                                <ButtonSave
                                  isSend
                                  loading={disabled || loading}
                                  disabled={disabled}
                                  onClick={async () => {
                                    await sendDocument(
                                      documentData,
                                      listDocuments,
                                      setListDocuments,
                                      index,
                                      setDisabled,
                                      onClose
                                    );
                                  }}
                                >
                                  Enviar
                                </ButtonSave>

                                {page !== listDocuments?.length - 1 &&
                                  listDocuments?.length !== 1 && (
                                    <ButtonSave
                                      style={{ marginLeft: "12px" }}
                                      loading={disabled || loading}
                                      onClick={() => {
                                        window.document
                                          .getElementsByClassName(
                                            "control-arrow control-next"
                                          )[0]
                                          .click();
                                      }}
                                    >
                                      Próximo
                                    </ButtonSave>
                                  )}
                              </div>
                            </div>
                          </span>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })
            )}
            {/* {} */}
          </Carousel>
        </DialogContent>
      </DialogStyle>
    </Modal>
  );
};

export default DocumentDialog;
